export const PURE = (type) => `${type}_PURE`;
//# sourceMappingURL=consts.js.map